import { defineStore } from "pinia";

export const useAlertStore = defineStore({
  id: "alert",
  state: () => ({
    isVisible: false,
    type: "" as "success" | "error" | "warning" | "info",
    message: "",
  }),
  actions: {
    show(type: "success" | "error" | "warning" | "info", message: string) {
      this.isVisible = true;
      this.type = type;
      this.message = message;
    },
    hide() {
      this.isVisible = false;
    },
  },
});
